module.exports = __webpack_public_path__ + "static/media/type2dialog.1e065831.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logos/type2dialog.png
// module id = 908
// module chunks = 0